/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

/** @jsx jsx */
import { jsx, css } from '@emotion/react'

import { EuiBadge, useEuiTheme } from '@elastic/eui'

import { FormattedMessage } from '@modules/i18n'
import { DocLink } from '@modules/doclinks'

import type { FunctionComponent } from 'react'

const AutoscalingBadge: FunctionComponent = () => {
  const { euiTheme } = useEuiTheme()

  const badgeStyles = css({
    borderColor: euiTheme.colors.vis.euiColorVis1, // $euiColorVis1
    color: euiTheme.colors.vis.euiColorVis1,
  })

  return (
    <EuiBadge color='hollow' css={badgeStyles}>
      <DocLink link='autoscalingDocLink'>
        <FormattedMessage
          id='configuration-change.autoscaling-badge'
          defaultMessage='Autoscaling triggered event'
        />
      </DocLink>
    </EuiBadge>
  )
}

export default AutoscalingBadge
